<script setup>
import BaseDashboardBanner from './BaseDashboardBanner.vue'
</script>

<template>
  <BaseDashboardBanner
    buttonText="Try it Now"
    buttonLink="/analyze/reports/overview?utm_source=gtowizard&utm_medium=dashboard&utm_campaign=gto_reports&utm_content=banner"
  >
    <template #background>
      <div class="biggest_feud_inner_back" />
    </template>
    <template #content>
      <span style="font-size: 2.05rem; font-weight: 600"
        ><span class="clr-primary">Introducing GTO Reports - Flop Overview</span></span
      >
      <span
        class="weight_400"
        style="font-size: 1.3rem; font-weight: 400; color: #ebebeb"
        >Upload your hands. Get a full GTO solver breakdown.<br />
        Find the leaks. Fix them forever.</span
      >
    </template>
  </BaseDashboardBanner>
</template>

<style lang="scss" scoped>
.biggest_feud_inner_back {
  z-index: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0%;
  z-index: -1;
  background: url('@/assets/img/app_banner_gto_reports_flop.webp');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
}
</style>
